import React, { ComponentChildren, FunctionComponent, h } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars
import { useState } from "preact/hooks";

import cx from "classnames";

import SVGIcon from "../../../app/components/SVGIcon";

export interface IConcertina {
  className?: string;
  title: string;
  description?: string;
  additionalText?: string | null;
  id: string;
  isRichtext: boolean;
  children?: ComponentChildren;
  isOpenByDefault?: boolean;
  isCompact?: boolean;
  isRelatedDocuments?: boolean;
}

const Concertina: FunctionComponent<IConcertina> = ({
  className,
  title,
  description,
  additionalText,
  id,
  children,
  isRichtext,
  isRelatedDocuments = false,
  isOpenByDefault = false,
  isCompact = false,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(isOpenByDefault);

  const open = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={cx("concertina__item accordion-item", className)}>
      <div
        className="concertina__header accordion-head"
        tabIndex={0}
        role="button"
        aria-label="true"
      >
        <button
          className={cx("concertina__trigger concertina__trigger--button unbutton", {
            "concertina__trigger--compact": isCompact,
          })}
          aria-controls={`.concertina__body-wrapper--${id}`}
          onClick={open}
          role="tab"
          aria-selected={isOpen}
          aria-expanded={isOpen}
        >
          <span className="concertina__title">
            {isRelatedDocuments && (
              <SVGIcon
                name="document-related"
                className="concertina__icon--document-related"
              />
            )}
            {title}
          </span>
          <SVGIcon
            name="cross"
            className="concertina__icon concertina__icon--closed"
          />
          <SVGIcon
            name="dash"
            className="concertina__icon concertina__icon--open"
          />
        </button>
      </div>
      <div
        className={cx(`concertina__body-wrapper concertina__body-wrapper--${id} accordion-body`, {
          expand: isOpen,
          collapse: !isOpen,
        })}
        aria-hidden={isOpen}
        tabIndex={isOpen ? 0 : -1}
        hidden={isOpen ? undefined : true}
      >
        <div
          className={cx("concertina__body", {
            "richtext-content": isRichtext,
          })}
        >
          {description && <div dangerouslySetInnerHTML={{ __html: description }} />}
          {additionalText && <div dangerouslySetInnerHTML={{ __html: additionalText }} />}
          {children}
        </div>
      </div>
    </div>
  );
};

export default Concertina;
